export enum PersonTitles {
    MR = 'Mr',
    MRS = 'Mrs',
    MS = 'Ms',
    MISS = 'Miss',
}
